__turbopack_context__.v({
  "breakWordText": "NMTfeG_breakWordText",
});
